<div class="titulo-rotina-container">
  @if (mostrarBotaoMenu) {
    <button type="button" class="titulo-rotina-btn-menu" (click)="clicarMenu()" aria-label="Abrir menu">
      <img [src]="iconeMenu" alt="" class="titulo-rotina-icone-menu" />
    </button>
  }
  @if (mostrarBotaoVoltar) {
    <button type="button" class="titulo-rotina-btn-voltar" (click)="clicarVoltar()" aria-label="Voltar">
      <img [src]="iconeVoltar" alt="" class="titulo-rotina-icone-voltar" />
    </button>
  }
  <div class="titulo-rotina-textos">
    <p class="titulo-rotina-titulo">{{ titulo }}</p>
    @if (subtitulo) {
      <p class="titulo-rotina-subtitulo">{{ subtitulo }}</p>
    }
  </div>
</div>
